// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StudentBadgeRepresentation
 */
export interface StudentBadgeRepresentation {
  /**
   *
   * @type {Date}
   * @memberof StudentBadgeRepresentation
   */
  awardDateUtc: Date
  /**
   *
   * @type {number}
   * @memberof StudentBadgeRepresentation
   */
  lesson: number
  /**
   *
   * @type {string}
   * @memberof StudentBadgeRepresentation
   */
  badgeColour: string
}

/**
 * Check if a given object implements the StudentBadgeRepresentation interface.
 */
export function instanceOfStudentBadgeRepresentation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'awardDateUtc' in value
  isInstance = isInstance && 'lesson' in value
  isInstance = isInstance && 'badgeColour' in value

  return isInstance
}

export function StudentBadgeRepresentationFromJSON(
  json: any,
): StudentBadgeRepresentation {
  return StudentBadgeRepresentationFromJSONTyped(json, false)
}

export function StudentBadgeRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentBadgeRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    awardDateUtc: new Date(json['awardDateUtc']),
    lesson: json['lesson'],
    badgeColour: json['badgeColour'],
  }
}

export function StudentBadgeRepresentationToJSON(
  value?: StudentBadgeRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    awardDateUtc: value.awardDateUtc.toISOString(),
    lesson: value.lesson,
    badgeColour: value.badgeColour,
  }
}
